import { useQuery } from 'react-query';

import { assetsApi } from 'src/Services/API';

export const useFetchAssets = () => {
  return useQuery({
    queryKey: ['fetch-assets'],
    queryFn: async () => {
      return (await assetsApi.assetsControllerFindAll()).data;
    },
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
  });
};
